var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyPaxtonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 346.1 82.4",
    style: {
      enableBackground: "new 0 0 346.1 82.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#56AA1C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_11637",
    d: "M109.1,2.8c4.7-0.8,9.5-1.2,14.3-1.1c7.3,0,12.7,1.7,16.2,4.8c3.2,2.7,5.1,6.9,5.1,12 c0,5.2-1.5,9.3-4.4,12.3c-3.9,4.2-10.3,6.3-17.6,6.4c-2,0.1-4-0.1-6-0.5l0,23.1l-7.4,0L109.1,2.8z M116.6,30.6 c2,0.5,4.1,0.6,6.2,0.6c9,0,14.4-4.4,14.4-12.3c0-7.6-5.4-11.3-13.6-11.3c-2.4-0.1-4.7,0.1-7,0.6L116.6,30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11638",
    d: "M175,59.6l-0.6-5.2h-0.3c-3,4-7.7,6.3-12.6,6.2c-8.4,0-12.7-5.9-12.7-11.9c0-10,8.9-15.5,24.8-15.4v-0.9 c0-3.4-1-9.6-9.4-9.6c-3.8,0-7.5,1.1-10.8,3.1l-1.7-5c4.1-2.5,8.8-3.8,13.6-3.7c12.6,0,15.7,8.6,15.8,16.9l0,15.5 c0,3.3,0.2,6.6,0.7,9.9L175,59.6z M173.9,38.5c-8.2-0.2-17.5,1.3-17.5,9.3c0,4.9,3.3,7.2,7.1,7.2c4.5,0.1,8.5-2.7,10-6.9 c0.3-0.8,0.4-1.6,0.4-2.4L173.9,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11639",
    d: "M196.8,18.2l5.9,8.9c1.5,2.3,2.8,4.4,4.2,6.7h0.3c1.4-2.5,2.7-4.6,4.1-6.8l5.8-8.8l8.1,0l-14.1,20 l14.6,21.3l-8.5,0l-6.1-9.3c-1.6-2.4-3-4.7-4.5-7.2h-0.2c-1.4,2.5-2.8,4.7-4.3,7.2l-6,9.3l-8.3,0l14.7-21.1l-14-20.2L196.8,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11640",
    d: "M243,6.3l0,11.9l10.8,0l0,5.7l-10.8,0l0,22.3c0,5.1,1.5,8,5.7,8c1.5,0,2.9-0.2,4.4-0.5l0.4,5.6 c-2.1,0.8-4.4,1.1-6.7,1c-3.5,0-6.3-1.1-8.1-3.1c-2.1-2.2-2.9-5.9-2.9-10.8l0-22.6l-6.4,0l0-5.7l6.4,0l0-9.9L243,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11641",
    d: "M299.1,38.4c0,15.3-10.6,22-20.6,22c-11.2,0-19.8-8.2-19.9-21.2c0-13.8,9-22,20.5-22 C291.1,17.1,299.1,25.7,299.1,38.4 M266.3,38.9c0,9.1,5.2,15.9,12.6,15.9c7.2,0,12.5-6.8,12.5-16.1c0-7-3.5-15.9-12.4-15.9 S266.3,31,266.3,38.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11642",
    d: "M308.6,29.2c0-4.3-0.1-7.8-0.4-11.2l6.7,0l0.4,6.8h0.2c2.8-4.9,8-7.9,13.7-7.8c5.7,0,14.6,3.4,14.6,17.6 l0,24.7l-7.5,0l0-23.8c0-6.7-2.5-12.2-9.6-12.2c-4.7,0.1-8.8,3.2-10.1,7.7c-0.4,1.1-0.5,2.3-0.5,3.5l0,24.9l-7.5,0L308.6,29.2z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.5,32.8c0-3.7-0.2-6.5-0.3-9.8h3.7l0.3,7.2h0.2c2.6-4.7,6.5-8.2,13.2-8.2c5.7,0,10,3.7,11.7,8.9h0.2 c1.2-2.5,2.6-4.2,4.2-5.5c2.6-2.2,5.4-3.4,9.8-3.4c4,0,13.3,2.2,13.3,17.7v24.1h-4V40.2c0-9.2-3.6-14.6-10.6-14.6 c-5.1,0-9.2,3.7-10.7,8.1c-0.4,1.2-0.8,2.6-0.8,4v26.2h-4V38.3c0-7.4-3.6-12.8-10.1-12.8c-5.5,0-9.8,4.4-11.3,9.2 c-0.4,1.1-0.7,2.6-0.7,3.9v25.2h-4V32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.7,23l10.7,26.7c1.1,2.9,2.2,6.1,3,8.8h0.2c0.9-2.5,1.9-5.7,3.1-9L97.6,23h4.3L89.7,53.4 c-4.9,12.7-8.4,20.2-13.8,24.9c-3.2,2.7-6.1,3.9-7.1,4.2l-1.3-3.4c2-0.8,4.8-2.2,7.1-4.6c2-2,4.8-5.4,6.8-10.2 c0.3-0.9,0.5-1.4,0.5-1.8s-0.2-0.9-0.5-1.8L66.3,23H70.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPaxtonLogo);
export default __webpack_public_path__ + "static/media/MyPaxton Logo.9d80773c815f522b1aad16410b9ac28e.svg";
export { ForwardRef as ReactComponent };